export const ControllPassword =  () => {

  const rules = document.querySelectorAll('.ControllPassword-control');
  const input = document.getElementById('password');

  if(!input || rules.length === 0) return null;

   const passwordControls = [
    {
      label: 'charsetCount',
      regex: /^.{8,}$/
    },
    {
      label: 'lowerCase',
      regex: /(?=.*[a-z])/,
    },
    {
      label: 'upperCase',
      regex: /(?=.*[A-Z])/,
    },
    {
      label: 'specialCharset',
      regex: /\W/,
    },
    {
      label: 'digit',
      regex: /\d/
    },
  ];
  input.addEventListener('input',(e) => checkPassword(e));

  const checkPassword = ({target}) => {
    let noMatchingCount = 0;
    passwordControls.forEach(({label,regex}) => {
      if(!!target.value.match(regex)?.length) {
        [...rules].find(rule => rule.dataset.control === label)?.classList.add('is-valid');
      }
      else {
        [...rules].find(rule => rule.dataset.control === label)?.classList.remove('is-valid');
        noMatchingCount++
      }
    });

    if(noMatchingCount === 0) {
      target.classList.add('success');
      target.classList.remove('error');
      input.parentNode.classList.add('is-active');
    }
    else {
      target.classList.remove('success');
      target.classList.add('error');
      input.parentNode.classList.remove('is-active');
    }
  }
}

export const ControllConfirmation = () => {
  const input = document.getElementById('password');
  const confirmation = document.getElementById('password_confirmation');

  [input,confirmation].forEach((i) => {
    i?.addEventListener('input', () => {
      if(confirmation.value === input.value && input.value !== "") {
        confirmation.classList.add('success');
        confirmation.classList.remove('error');
        confirmation.parentNode.classList.add('is-active');

      }
      else {
        confirmation.classList.remove('success');
        confirmation.classList.add('error');
        confirmation.parentNode.classList.remove('is-active');
      }
    })
  })
}
